import React, { useState, useEffect } from 'react'

import { Link } from 'react-router-dom'

import styled from 'styled-components'
import { NavBar } from '../../components/navbar'

import { useDispatch, useSelector } from 'react-redux'

import { getResourceCategory } from '../../pages/features/resourcecategory/resourcecategorySlice'


// resourcecategorySlice

const NigerianaCategories = () => {

    const dispatch = useDispatch()

    
    const { resourceCategory, resourceCategoryStatus, } = useSelector(state => state.resourceCategory);

    useEffect(() => {

        dispatch(getResourceCategory());

    }, [resourceCategoryStatus, dispatch]);


  return (
    <Container>
        <NavBar />
        
        <InnerContainer>

            <h2>Nigeriana Categories</h2>

            <CatContainer> 

            {
                resourceCategory.map((category) => {
                    return(
                        <CatContainer key={category.resourceCategoryId}> 
                                <StyledLink to={`/nigeriana/category/${category.resourceCategoryId} `} >
                                    {category.resourceCategoryName} 
                                </StyledLink>
                        </CatContainer>
                        
                    )
                })
            }

            </CatContainer>

        </InnerContainer>
        
        
    </Container>
  )
}

const Container =  styled.section`
    width: 100%;
    max-width: 1250%;
    margin: 0 auto;  
`
const InnerContainer = styled.div`
    width: 80%;
    max-width: 1250%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    /* align-items: center; */
    
    & > h2{
        margin-top: 35px;
    }

    & > p{

    }
    `
const CatContainer = styled.div`
    width: 100% !important;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    gap: 1rem;
    column-gap: 1rem;
    justify-content: space-between;

    @media screen and (max-width: 600px){
            display: flex;
            flex-direction: column;
            align-items: center;
            /* font-weight: 500; */
        }
`;

    
const StyledLink = styled(Link)`

    text-decoration: none;
    padding: 28px 0px;
    width: 250px !important;
    background: #FFFFFF;
    box-shadow: 0px 4px 4px rgba(255, 255, 255, 0.25), 0px 4px 4px rgba(0, 0, 0, 0.15);
    border-radius: 4px;
    font-size: 15px;
    font-weight: 600;
    text-align: center;
    /* width: fit-content; */
    color: #101828;

    &:hover{
        transition: all .3s ease-out;
        color: #727171;
    }
    
    `    
export {NigerianaCategories}